import { SettingsService } from "library-explorer";
import { AuthenticationService } from "../services/authentication.service"
import { UtilitiesService } from "../services/utilities.service";

export function initializeAppFactory(authService: AuthenticationService, utilities: UtilitiesService, settingsService: SettingsService): () => void {
  return () => {
    utilities.init();
    settingsService.getSettingsData().subscribe();

    authService.refreshCsrfToken();
    authService.init()
  }
}
